export default "__VITE_ASSET__bc21c7a2__"